export default {"src":"/_next/static/media/close.99b0277f.svg","height":25,"width":25};